import styled from 'styled-components';
import { colors } from './theme';

export const Main = styled.main`
  .db-tab-controls {
    border-bottom: 1px solid #b5b5b5;
    padding: 0;
    list-style-type: none;
    display: flex;
    margin-bottom: 35px;

    li {
      margin: 0 5px;

      &.active,
      &:hover {
        a {
          color: ${colors.blue};

          &:before {
            width: 100%;
          }
        }
      }

      a {
        padding: 15px;
        display: block;
        color: #b5b5b5;
        font-size: 16px;
        font-weight: 500;
        position: relative;

        &:before {
          position: absolute;
          bottom: -1px;
          left: 0;
          right: 0;
          width: 0;
          height: 2px;
          background-color: ${colors.blue};
          content: '';
          transition: 0.3s ease;
          margin: 0 auto;
        }
      }
    }
  }
`;
